export const LOADING_PROJECTS = "LOADING_PROJECTS"
export const LOADING_DELETED_PROJECTS = "LOADING_DELETED_PROJECTS"

export const LOADING_RESTORE_PROJECT = "LOADING_RESTORE_PROJECT"
export const RESTORE_PROJECT = "RESTORE_PROJECT"
export const RESTORE_PROJECT_FAIL = "RESTORE_PROJECT_FAIL"

export const FETCH_PROJECTS = "FETCH_PROJECTS"
export const FETCH_DELETED_PROJECTS = "FETCH_DELETED_PROJECTS"

export const SET_FAIL_MESSAGE = "SET_FAIL_MESSAGE"

export const FETCH_PROJECTS_FAIL = "FETCH_PROJECTS_FAIL"
export const FETCH_DELETED_PROJECTS_FAIL = "FETCH_DELETED_PROJECTS_FAIL"

export const CLEAR_PROJECTS = "CLEAR_PROJECTS"
export const CLEAR_DELETED_PROJECTS = "CLEAR_DELETED_PROJECTS"
